import React from 'react';

import { UiSpinner } from '@/components/ui/Spinner';
import { SELECT_PLAN_SECTION_ID } from '@/constants';
import { useStripeV2Plans } from '@/hooks/useStripeV2Plans';

import { OneDayVIPPaymentDescription } from '../../components/PaymentDescription/OneDayVIPPaymentDescription';
import { OneDayVIPSubscriptionData } from '../../components/SubscriptionButton/components/OneDayVIPSubscriptionData/OneDayVIPSubscriptionData';

import { OneDayVIPButtonStyles } from './OneDayVIPSelectPlan.styles';
import {
  SelectPlanListStyles,
  SelectPlanStyles,
  SpinnerContainerStyles,
} from './SelectPlan.styles';

export const OneDayVIPSelectPlan: React.FC<{
  vipTitle?: string;
  buttonProps?: {
    onClick?: () => void;
    text?: string;
  };
  isPromoCodeVisible?: boolean;
  sectionId?: string;
}> = ({ vipTitle, buttonProps, sectionId = SELECT_PLAN_SECTION_ID }) => {
  const { isLoadingPlans, selectedPlan, stripePlans } = useStripeV2Plans();

  if (isLoadingPlans) {
    return (
      <SelectPlanStyles id={sectionId}>
        <SpinnerContainerStyles>
          <UiSpinner size="lg" className="white-spinner" />
        </SpinnerContainerStyles>
      </SelectPlanStyles>
    );
  }

  return (
    <SelectPlanStyles id={sectionId}>
      <SelectPlanListStyles>
        {stripePlans.map((subscription) => (
          <OneDayVIPSubscriptionData
            subscription={subscription}
            vipTitle={vipTitle}
            key={subscription.id}
          />
        ))}
      </SelectPlanListStyles>
      <OneDayVIPButtonStyles
        type="button"
        onClick={() => {
          if (buttonProps?.onClick) {
            buttonProps.onClick();
          }
        }}
      >
        Become VIP
      </OneDayVIPButtonStyles>

      {selectedPlan && (
        <OneDayVIPPaymentDescription selectedPlan={selectedPlan} />
      )}
    </SelectPlanStyles>
  );
};
